/**
 * Docked Shogun frame hosting the platform chat (app-shell ADR-013).
 * Bridge + confirm stay on {@link MainLayout} so they outlive this panel.
 */

import { ShogunPanelFrame } from './ShogunPanelFrame';
import { PanelChat } from '../chat/PanelChat';
import type { UseShogunDock } from './useShogunDock';

export interface ShogunPanelProps {
  dock: UseShogunDock;
}

export function ShogunPanel({ dock }: ShogunPanelProps) {
  // Chat route owns the surface; a second mount would fight the singleton
  // session/draft/layout atoms (app-shell ADR-020).
  if (dock.suppressed) return null;
  if (!dock.open) return null;

  return (
    <ShogunPanelFrame
      mode={dock.mode}
      floating={dock.floating}
      onFloatingChange={dock.setFloating}
      onFloatingCommit={dock.commitFloating}
      docked={dock.docked}
      onDockedChange={dock.setDocked}
      onDockedCommit={dock.commitDocked}
      title={dock.personaName}
    >
      <PanelChat />
    </ShogunPanelFrame>
  );
}
